import { CountryCode } from "libphonenumber-js";

export const $PhonenumberPrefixesModuleName = "phonenumberPrefixes";

export type PhonenumberPrefix = {
    country: {
        isoCode: CountryCode;
        name: string;
    };
    prefix: string;
};

export type TPhonenumberPrefixesState = Array<PhonenumberPrefix>;
